<template>
  <b-modal
    v-model="innerIsOpen"
    :can-cancel="false"
    has-modal-card
    trap-focus
    aria-role="dialog"
    aria-label="Informe sua situação"
    aria-modal
    @close="onClose"
  >
    <template>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title pr-6">Informe sua situação</p>
        </header>
        <section class="modal-card-body is-relative" style="min-height: 300px">
          <p>Oi! Já faz um tempo que você atualizou sua situação...</p>
          <p class="mb-5">
            Responda essa pergunta rapidinho para continuar utilizando a
            plataforma!
          </p>
          <b-select-with-validation
            v-model="statusDoenca"
            label="Qual a sua situação em relação ao COVID-19?"
            :loading="isLoadingStatusDoenca"
            rounded
            expanded
          >
            <template v-for="opcao in opcoes_status_doenca">
              <option :key="opcao.id" :value="opcao.id">
                {{ opcao.nome }}
              </option>
            </template>
          </b-select-with-validation>
          <b-field>
            <b-autocomplete-with-validation
              rules="required|max:64"
              v-model="doencaDigitada"
              :data="doencasFiltradas"
              icon="magnify"
              label="Doença"
              @select="option => (doenca = option)"
              open-on-focus
              clearable
              rounded
              ref="doenca"
              autocomplete="false"
              field="nome"
              append-to-body
            >
              <template #header>
                <a @click="mostrarAdicionarDoenca">
                  <span> Outra doença... </span>
                </a>
              </template>
            </b-autocomplete-with-validation>
          </b-field>
        </section>
        <footer class="modal-card-foot buttons is-right">
          <b-button @click="sair" label="Sair" />
          <b-button
            @click="submit"
            :loading="isLoading"
            label="Confirmar"
            type="is-primary"
          />
        </footer>
      </div>
    </template>
  </b-modal>
</template>
<script>
import BSelectWithValidation from '@/components/UI/BSelectWithValidation.vue';
import BAutocompleteWithValidation from '@/components/UI/BAutocompleteWithValidation.vue';
import { mapActions } from 'vuex';
import axios from '@/api';

export default {
  components: {
    BSelectWithValidation,
    BAutocompleteWithValidation,
  },
  props: {
    isModalOpen: Boolean,
    onClose: Function,
  },
  data() {
    return {
      doenca: null,
      statusDoenca: null,
      opcoes_status_doenca: [],
      innerIsOpen: this.isModalOpen,
      isLoadingStatusDoenca: false,
      isLoading: false,
      doencas: [],
      doencaDigitada: '',
    };
  },
  computed: {
    doencasFiltradas() {
      return this.doencas.filter((option) => (
        option.nome
          .toString()
          .toLowerCase()
          .indexOf(this.doencaDigitada.toLowerCase()) >= 0
      ));
    },
  },
  watch: {
    innerIsOpen(newVal) {
      this.$emit('toggle', newVal);
    },
    isModalOpen(newVal) {
      this.innerIsOpen = newVal;
      if (newVal) {
        this.loadStatusDoenca();
      }
    },
  },
  created() {
    this.loadDoencas();
    this.loadStatusDoenca();
  },
  methods: {
    ...mapActions(['logout']),
    mostrarAdicionarDoenca() {
      this.$buefy.dialog.prompt({
        message: 'Doenca',
        inputAttrs: {
          placeholder: 'Digite o nome de sua doenca',
          maxlength: 64,
          value: this.doencaDigitada,
        },
        confirmText: 'Adicionar',
        onConfirm: (value) => {
          this.doencas.push(value);
          this.$refs.doenca.$refs.autocomplete.setSelected(value);
        },
      });
    },
    sair() {
      this.logout();
      this.innerIsOpen = false;
    },
    loadDoencas() {
      this.isLoadingStatusDoenca = true;
      axios
        .get('/epidemias')
        .then((res) => {
          const doencas = res.data.epidemias;
          this.doencas = doencas;
          [this.doenca] = doencas;
          this.doencaDigitada = doencas[0].nome;
        })
        .finally(() => {
          this.isLoadingStatusDoenca = false;
        });
    },
    loadStatusDoenca() {
      this.isLoadingStatusDoenca = true;
      axios
        .get('/status_doenca')
        .then((res) => {
          const opcoesStatusDoenca = res.data.status_doenca;
          this.opcoes_status_doenca = opcoesStatusDoenca;

          const opcaoSelecionada = opcoesStatusDoenca.find(
            (opcao) => opcao.sigla === 'C',
          );
          this.statusDoenca = opcaoSelecionada.id;
        })
        .finally(() => {
          this.isLoadingStatusDoenca = false;
        });
    },
    submit() {
      const data = {
        status_doenca: this.statusDoenca,
        epidemia: this.doenca.id,
      };
      this.isLoading = true;
      axios
        .post('/atualizacao_rapida', data)
        .then(() => {
          this.$buefy.notification.open({
            message: 'Situação atualizada com sucesso!',
            type: 'is-success',
          });
          this.innerIsOpen = false;
        })
        .catch((err) => {
          let message = 'Houve um erro ao fazer o login!';
          message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : message;
          this.$buefy.notification.open({
            message,
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
